import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
import { UsertokenService } from '@shared-angular/services/usertoken.service';
import QueryString from 'qs';
import { firstValueFrom } from 'rxjs';
import { EventManagerService } from '../../event-manager/event-manager.service';
import { AiImageFile } from './openaiImage.service';

/** Erzeugt Bilder per Stable Diffusion (`RAGAI.AIIMAGE_STABLEDIFFUSION`). */
/**
 * Erzeugt Bilder per Stable Diffusion (`RAGAI.AIIMAGE_STABLEDIFFUSION`).
 * @remarks
 * Einziger der drei Bild-Provider (`AIIMAGE_OPENAI`/`_FALAI`/`_STABLEDIFFUSION`) mit einem `negative_prompt`-Parameter
 * (beschreibt, was im Bild vermieden werden soll) - eine Eigenheit von Stable-Diffusion-Modellen, die es bei den
 * anderen beiden Providern nicht gibt. Nutzt intern die alten `io_out_`/`io_in_`-Socket-Events statt der neueren
 * `_trigger_RAGAI_EVENT`-Konvention der Schwesterklassen (funktional äquivalent, nur historisch gewachsen).
 */
@Injectable({
  providedIn: 'root'
})
export class StableDiffusionImageService {

  constructor(private eventManager: EventManagerService,
    private http: HttpClient,
    private botIdService: BotidService,
    private usertokenService: UsertokenService
  ) {
  }

  /**
   * Generiert ein Bild per Stable-Diffusion-Modell.
   * @param prompt Der Text-Prompt für die Bildgenerierung.
   * @param opts Zusätzliche Optionen.
   * @param opts.negative_prompt Beschreibt, was im Bild vermieden werden soll.
   * @param opts.image Referenzbild-URL für die Bildbearbeitung.
   * @param opts.images Mehrere Referenzbilder für die Bildbearbeitung.
   * @param opts.aspectRatio Gewünschtes Seitenverhältnis des Ergebnisbildes.
   * @returns Die erzeugte Bilddatei.
   */
  public async create(prompt: string, opts: { negative_prompt?: string, image?: string, images?: string[], aspectRatio?: string } = {}) {
    this.eventManager.triggerEventHook("io_out_stablediffimagecreation_start", { prompt, opts });
    const query = QueryString.stringify({
      prompt,
      ...opts,
      ...(opts.images && { images: JSON.stringify(opts.images) })
    });
    const result = await firstValueFrom(this.http.get<AiImageFile>("/api/ai/image/create/stablediffusion/" + this.botIdService.getBotId() + "?" + query));
    this.eventManager.triggerEventHook("io_in_stablediffimagecreation_end", { prompt, opts, result });
    return result;
  }

  /**
   * Erstellt eine ladbare URL für ein zuvor erzeugtes Bild.
   * @param fileId ID der Bilddatei.
   * @returns Die URL zum Laden des Bildes.
   */
  public getImageUrl(fileId: string) {
    return "/api/ai/image/load/" + this.botIdService.getBotId() + "/" + fileId + "?Ut=" + this.usertokenService.getUserToken();
  };
}
